/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState,useRef } from 'react';
import { APIEndpoint } from '../../../../utils/axios';
import { IoPerson } from "react-icons/io5";
import LoadingGIF from '../../../../assets/loadingIn.gif';
import { IoArrowForwardOutline } from "react-icons/io5";
import moment from 'moment';
import {formatCamelString,getCultureFromLs} from '../../../../utils/commonFunctions';
import { CollapsebleSectorInstance } from '../../../../common';

function SectorInstanceContainer(props) {
  const [sectors, setSectors] = useState(()=>{
    const resSect=sessionStorage.getItem('Sectors');
    return resSect?JSON.parse(resSect):[]
  });
  const [sectorIsolateData, setSectorIsolateData] = useState(()=>{
    const resISo=sessionStorage.getItem('SectorData');
    return resISo?JSON.parse(resISo):{};
  });
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const containerRef = useRef();

  useEffect(() => {
    const updateHeight = () => {
      const availableHeight = window.innerHeight * 0.55;
      if (containerRef.current) {
        containerRef.current.style.maxHeight = `${availableHeight}px`;
      }
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  const getSectorData = async (id) => {
    if(Object.keys(sectorIsolateData).length && sectors.length)return;
    setLoading(true);
  //   const body={
  //     isolateId: id
  // }
    try {
      const res = await APIEndpoint.get(`sandboxing/containerIsolates/${id}`);
      if (res.isolate) {
        sessionStorage.setItem('SectorData',JSON.stringify(res.isolate));
        setSectorIsolateData((prev) => ({ ...prev, ...res.isolate }));
        const sectData = res.isolate.sectors.map(async (sec) => {
          const res = await APIEndpoint.get(
            `sandboxing/isolatedSectors/${sec.id}?mutableOnly=${true}`
          );
          return res.sector || null;
        });
        const resolvedSectors = await Promise.all(sectData);
        sessionStorage.setItem('Sectors',JSON.stringify(resolvedSectors.filter((sector) => sector !== null)));
        setSectors(resolvedSectors.filter((sector) => sector !== null));
        setLoading(false);

        }

    } catch (error) {
      setLoading(false);
    }
  };
  const handleView = (id) => {
    setSelectedItemIndex(prevIndex => (prevIndex === id ? null : id));
  };

  useEffect(() => {
    if (props.sectorId) {
      const { sectorId } = props;
      getSectorData(sectorId);
    }
  }, [props]);

const CrewLabels = (list,op=null) => {
  if (list.length) {
    return (
     <div className="crew-container">
      {[...list].sort((a,b)=> a.employeeName?.length - b.employeeName?.length).map((member, idx) => (
        <div
          key={
            member.employeeCode ||
            `${member.employeeName || 'unknown'}-${member.role || 'unknown'}-${member.position || 'unknown'}`
          }
          className="employee-crew"
        >
          <div className="crew-avatar">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
              <circle cx="20" cy="20" r="20" fill="#1d3f4f"/>
              <circle cx="20" cy="15" r="7" fill="#4a90a4"/>
              <path d="M6 36c0-7.732 6.268-14 14-14s14 6.268 14 14" fill="#4a90a4"/>
            </svg>
          </div>
          <div title={member?.employeeName} className="crew-info">
            <span className="crew-name">{member.employeeName}</span>
            <span className="crew-code">{member.employeeCode}</span>
          </div>
          <div className="crew-role-badge">  {op && member?.position ?`(${member.role} @ ${member.position})` : `(${member.role})`}</div>
        </div>
      ))}
</div>
    );
  } else {
    return !op?"No crew members added yet":"No information about operating crew available.";
  }
}

  const upliftsSectors=(sect,list)=>{
    if (list.length) {
      return (
        <div className="flexRow flexWrap">
          {list.map((item, index) => (
            <button key={index} className="status-dynamic margRight" onClick={()=>props.inventoryDetails(sect,index,'uplifts',null,sectorIsolateData?.sectors[index])} style={{ width:list.length<=1?'17rem':'10rem',marginRight: '2px',whiteSpace:'nowrap',backgroundColor: '#06cc48' }}>Uplift from {item.warehouse?.warehouseCode}</button>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }

  const getSectorStatus = (sec) => {
    switch (sec) {
      case 'open':
        return <div className="status-instance" style={{ backgroundColor: '#03a5fc' }}>Active</div>;
      case 'locked':
        return <div className="status-instance" style={{ backgroundColor: '#f03630' }}>Locked</div>;
        case 'cancelled':
        return <div className="status-dynamic" style={{ backgroundColor: '#f03630' }}>Cancelled</div>;
        case 'unknown':
        return <div className="status-dynamic" style={{ backgroundColor: '#1d3f4f' }}>Unknown</div>;
      case 'committed':
        return <div className="status-instance" style={{ backgroundColor: '#09ab16' }}>Committed</div>;
        case 'completed':
          return <div className="status-dynamic" style={{ backgroundColor: '#09ab16' }}>Completed</div>;
      case 'commitScheduled':
        return <div className="status-instance" style={{ backgroundColor: '#f28016' }}>Commit Scheduled</div>;
      default:
        return "";
    }
  };

  const getSyncStatus = (sec) => {
    switch (sec) {
      case 'syncPending':
        return <div className="status-dynamic" style={{ backgroundColor: '#f03630' }}>{formatCamelString(sec)}</div>;
        case 'partiallySynced':
        return<><div className="status-dynamic" style={{ backgroundColor: '#ff9d15' }}>{formatCamelString(sec)}</div>&nbsp;<span>0%</span></> ;
        case 'synced':
        return<><div className="status-dynamic" style={{ backgroundColor: '#09ab16' }}>{formatCamelString(sec)}</div>&nbsp;<span>100%</span></> ;
      default:
        return <div className="status-dynamic" style={{ backgroundColor: '#1d3f4f' }}>{formatCamelString(sec)}</div>;
    }
  };



  useEffect(() => {
    const timer = setTimeout(() => {
      if (sectors.length === 0 && loading) {
        setLoading(false);
      }
    }, 3500);
const minTimer=setTimeout(()=>{

if(sectors.length && loading){
  setLoading(false)
}
},300)
    return () =>{ clearTimeout(minTimer);
      clearTimeout(timer);
    };
  }, [sectors, loading]);

  return (
    <ul ref ={containerRef} className='list-group' style={{overflowY:'scroll',height:'auto',maxHeight:'100%' }}>
      {loading ? (
        <li className='flexRow justifyContentCenter alignitemsCenter'>
          <div className='flexRow justifyContentCenter alignitemsCenter'>
            <img src={LoadingGIF}  className='icon-size' style={{width:'25px',height:'25px'}} alt="Loading" />
            <div className="margTop8">Please wait while we fetch currently attached data for this instance...</div>
          </div>
        </li>
      ) : sectors.length && sectorIsolateData.sectors ? (
        sectorIsolateData?.sectors?.map((item, index) => (

          <React.Fragment key={index}>
            <li
              className={`flexRow col-xs-11 wrapper-sector justifyContentSpaceBetween ${
                index === selectedItemIndex ? 'selected' : ''
              }`}
              onClick={(e) =>{e.stopPropagation(); handleView(item.id)}}
              style={{ cursor: 'pointer' }}
            >
              <div className="flexRow justifyContentCenter alignItemsCenter">
                <span className="justifyContentFlexStart instance-member fontExtrabold">{item.key.split("/")[0]}</span><span className="margLeft5 fontSemibold">{item.key.split("/")[1]}</span>
              </div>
              <div className="flexRow">
                <span className="justifyContentFlexEnd instance-member">
                  <IoPerson size={15} style={{ marginRight: '7px' }} />
                  {item.createdBy.employeeName}
                  {getSectorStatus(sectorIsolateData.state)}
                </span>
              </div>
            </li>
            {selectedItemIndex === item.id && (
              <CollapsebleSectorInstance id={item.id} selectedItemIndex={selectedItemIndex}>
              <div className='justifyContentSpaceBetween col-xs-11 wrapper-sector'>
                {sectors[index].originalSector?<div className='flexRow alignItemsCenter textAlignLeft sector-origin-m'>This sector was created because original sector<span className='code'>{sectors[index].originalSector.name}</span> was locked at the time of sync.</div>:null }
              <div className='flexRow sector-banner justifyContentSpaceBetween'>
                <div className='flexRow justifyContentFlexStart'>
                   <div className='sector-number fontMedium'>{item.flightNumber}</div>
                   <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow sector-tag'>{item.origin}</div>
                <div className='flexRow fontMedium'>{item.originName}</div>
                </div>
                </div>

                <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow'> <IoArrowForwardOutline size={17} color={'#F06548'}/></div>
                <div className='flexRow fontMedium'>{item.key.split("/")[1]}</div>
                </div>
               <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow sector-tag'>{item.destination}</div>
                <div className='flexRow fontMedium'>{item.destinationName}</div>
                </div>
              </div>
              <div className='flexRow fitContent'>
                  <div style={{float:'left'}} className="flexCol width50 justifyContentFlexStart margRight15">
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Sector ID</label>
                  <div>{item.name}</div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Operation Status</label>
                  <div>{getSectorStatus(sectors[index]?.operationStatus)}&nbsp;{sectors[index]?.cancellationReason?sectors[index]?.cancellationReason.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^([a-z])/, (match) => match.toUpperCase()):""}</div>
                </div>

                <div className='margBottom10'>
                  <label className='fontExtrabold'>Created At</label>
                  <div>{item.createdAt?moment(item.createdAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):'Not available'}</div>
                </div>

                <div className='margBottom10'>
                  <label className='fontExtrabold'>Created By</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {item.createdBy.employeeName}
                    </div>
                    {item.createdBy.employeeName && item.createdBy.employeeCode && item.createdBy.employeeName!== item.createdBy.employeeCode ? <div className='flexRow'>
                    {item.createdBy.employeeCode}
                    </div>:null}
                    </div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Created Using</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {item.userAgent.appName}@ {item.userAgent.appVersion}
                    </div>
                    <div className='flexRow'>
                    {item.userAgent.deviceModel},&nbsp;{item.userAgent.macId?`MAC ID: ${item.userAgent.macId}`:item.userAgent.deviceName}
                    </div>
                    </div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Started At</label>
                  <div>{sectors[index].startedAt?moment(sectors[index].startedAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):'Not Available'}</div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Ended At</label>
                  <div>{sectors[index].endedAt?moment(sectors[index].endedAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):"Not Available"}</div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Price List</label>
                  <div>{sectors[index]?.priceList??'Not available'}</div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Seat Price List</label>
                  <div>{sectors[index]?.seatPriceListName||'Unknown'}</div>
                </div>
                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Event Log</label>
                  <button className="status-dynamic dynamic-sl" onClick={(e)=>{e.stopPropagation();props.eventLogs(item,sectorIsolateData.sectors[index],null)}}>View Event Logs</button>
                </div>
                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Sales Summary</label>
             <button className="status-dynamic dynamic-sl" onClick={(e)=>{e.stopPropagation();props.inventoryDetails(sectors[index],null,'salesSummary',null,sectorIsolateData.sectors[index])}}>{item?.name}</button>

                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>PAX Reported by Crew </label>
                  <div>{sectors[index]?.pax??'Not available'}</div>
                </div>
                <div className=''>
                  <label className='fontExtrabold'>Crew</label>
                  <div>{CrewLabels(sectors[index]?.crew)}</div>
                </div>

              </div>
              <div className="flexCol width50">
    <div className='margBottom10'>
                  <label className='fontExtrabold'>Operating Crew</label>
                  <div>{CrewLabels(sectors[index].operatingCrew,"opCrew")}</div>
                </div>

              <div className='margBottom10'>
                  <label className='fontExtrabold'>Sync Status</label>
                  <div>{getSyncStatus(sectors[index]?.syncStatus)}</div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Synced At</label>
                  <div>{sectors[index]?.syncedAt?moment(sectors[index]?.syncedAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A'):'Not available'}</div>
                </div>

                <div className='margBottom10'>
                  <label className='fontExtrabold'>Number of Orders To Sync</label>
                  <div>{sectors[index]?.numberOfItemsToSync??'Not available'}</div>
                </div>

                <div className='margBottom10'>
                  <label className='fontExtrabold'>Number of Orders Synced</label>
                  <div>{sectors[index]?.numberOfItemsSynced??'Not available'}</div>
                </div>



                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Uplifts</label>
               {  sectors[index]?.uplifts.length? <>{upliftsSectors(sectors[index],sectors[index]?.uplifts)}</>:'None'}
                </div>

                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Transfer In</label>
                { sectors[index]?.transferInReport? <button className="status-dynamic" onClick={(e)=>{e.stopPropagation();props.inventoryDetails(sectors[index],null,'transferIn',null,sectorIsolateData.sectors[index])}} style={{ width:'17rem',whiteSpace:'nowrap',backgroundColor: '#06cc48' }}>{sectors[index]?.transferInReport?.sector?.name}</button>:<>None</>}
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Offloads</label>
                  <div>{sectors[index]?.offloads||'None'}</div>
                </div>
                <div className='margBottom10'>
                  <label className='fontExtrabold'>Wastages </label>
                  <div>{sectors[index]?.wastages||'None'}</div>
                </div>
                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Orders</label>
                  <button className="status-dynamic dynamic-act" onClick={(e)=>{e.stopPropagation();props.inventoryDetails(sectors[index],null,'ordersEditDocInstance',null,sectorIsolateData.sectors[index])}}>{item?.name}</button>

                </div>
                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Transfer Out</label>
               { sectors[index]?.transferOutReport?  <button className="status-dynamic dynamic-act" onClick={(e)=>{e.stopPropagation();props.inventoryDetails(sectors[index],null,'transferOut',null,sectorIsolateData.sectors[index])}}>{sectors[index]?.transferOutReport?.sector?.name}</button>:<>None</>}
                </div>
                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Uplift Audit Report  </label>
               { sectors[index]?.upliftAuditReport?  <button className="status-dynamic dynamic-upt" onClick={(e)=>{e.stopPropagation();props.inventoryDetails(sectors[index],null,'upliftAudit',null,sectorIsolateData.sectors[index])}}>{sectors[index]?.upliftAuditReport?.sector?.name}</button>:<>None</>}
                </div>
                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Transfer Audit Report </label>
                  { sectors[index]?.transferAuditReport?  <button className="status-dynamic dynamic-act" onClick={(e)=>{e.stopPropagation();props.inventoryDetails(sectors[index],null,'transferAudit',null,sectorIsolateData.sectors[index])}}>{sectors[index]?.transferAuditReport?.sector?.name}</button>:<>None</>}
                </div>
                <div className='flexCol margBottom10'>
                  <label className='fontExtrabold'>Stock Movement Overview </label>
                 {item.name? <button className="status-dynamic dynamic-sl" onClick={(e)=>{e.stopPropagation();props.inventoryDetails(sectors[index],null,'stockMvmnt',null,sectorIsolateData.sectors[index])}}>{item?.name||"None"}</button>:<>None</>}
                </div>
              </div>


              </div>
            </div>
              </CollapsebleSectorInstance>
            )}
          </React.Fragment>
        ))
      ) : (
        <li className='flexRow'>
          <div className='flexRow col-xs-11 wrapper-sector justifyContentCenter alignitemsCenter'>No sectors attached to this instance yet.</div>
        </li>
      )}
    </ul>
  )
}

export default SectorInstanceContainer;